import Symbol from "./Symbol";
import SymbolAnim from "./SymbolAnim";
import {pixiSetTimeout} from "../../framework/src/engine/pixi/pixiTimeout";

export default class SymbolWild extends Symbol{
    constructor(commander, speed) {
        super(commander, speed);
    }

    init() {
        //this.texture = PIXI.Texture.from("symbol_Wild_particle.png");
        this.yellowStars = [];
        this.length = 3.5;

        this.longLoop = 2;
        this.shortLoop = 2;
    }

    animateShort(symbol) {
        this.hideSymbol(symbol);
        return new Promise (res => {
            this.short(symbol).then(() => {
                res();
            });
        });
    }

    animateLong(symbol) {
        this.hideSymbol(symbol);
        return new Promise (res => {
            this.long(symbol).then(() => {
                res();
            });
        });
    }

    short(symbol) {
        return new Promise (res => {
            this.flares(symbol);
            let wild_container = this.displayWild(symbol);
            let shine_container = this.displayShine(symbol);
            pixiSetTimeout(.7*this.speed, () => {
                this.reflection(symbol);
                this.yellowStar(symbol);
            });
            this.shine(symbol, wild_container, shine_container).then(([shine_container, wild_container]) => {
                this.hideDiamonds(shine_container, wild_container);
                this.loopWild(this.shortLoop, shine_container, wild_container).then(([shine_container, wild_container]) => {
                    this.showDiamonds(shine_container, wild_container);
                    this.endWildShine(shine_container, wild_container).then(() => {
                        this.showSymbol(symbol);
                        this.clearStars(res);
                    });
                });
            });
        });
    }

    long(symbol) {
        return new Promise (res => {
            this.flares(symbol);
            let wild_container = this.displayWild(symbol);
            let shine_container = this.displayShine(symbol);
            pixiSetTimeout(.7*this.speed, () => {
                this.reflection(symbol);
                this.yellowStar(symbol);
            });
            this.shineLong(symbol, wild_container, shine_container).then(([shine_container, wild_container]) => {
                this.hideDiamonds(shine_container, wild_container);
                this.loopWild(this.longLoop, shine_container, wild_container).then(([shine_container, wild_container]) => {
                    this.showDiamonds(shine_container, wild_container);
                    this.endWildShine(shine_container, wild_container).then(() => {
                        this.showSymbol(symbol);
                        this.clearStars(res);
                    });
                });
            });
        });
    }

    loopWild(i,shine_container, wild_container) {
        return new Promise(res => {
            if (i === 0) {
                res([shine_container, wild_container]);
            } else {
                let obj = {x: 1.025, y: 1.025};
                createjs.Tween.get(obj,{loop: true})
                    .to({x: 1, y: 1}, 500 * this.speed, createjs.Ease.linear)
                    .call(() => {
                        if (--i < 1) {
                            SymbolAnim.removeTween(obj);
                            res([shine_container, wild_container]);
                        }
                    })
                    .to({x: 1.025, y: 1.025}, 500 * this.speed, createjs.Ease.quadOut)
                    .addEventListener("change", () => {
                        wild_container.children[0].scale.set(obj.x, obj.y);
                        wild_container.children[1].scale.set(obj.x, obj.y);
                        shine_container.children[0].scale.set(obj.x, obj.y);
                        shine_container.children[1].scale.set(obj.x, obj.y);
                    });

            }
        })
    }

    flares(symbol) {
        return new Promise(res => {
            let flares = SymbolAnim.createSprite(symbol.x, symbol.y, "symbol_Crown_flares.png", {x: 0.5, y: 0.48});
            flares.alpha = 0;
            flares.scale.set(1.1,1.1);

            this.layer.addChild(flares);
            createjs.Tween.get(flares)
                .wait(50 * this.speed)
                .to({alpha: 1}, 50 * this.speed, createjs.Ease.quadOut);

            createjs.Tween.get(flares, {loop: true})
                .to({rotation: 10*3.14}, 10*1000* this.speed, createjs.Ease.linear);


            let bg = SymbolAnim.createSprite(symbol.x, symbol.y, "symbol_Crown_background.png");
            bg.alpha = 0;
            this.layer.addChild(bg);

            createjs.Tween.get(bg)
                .wait(50*this.speed)
                .to({alpha: 1}, 150*this.speed, createjs.Ease.quadOut)
                .call(() => {SymbolAnim.removeTween(bg)});

            pixiSetTimeout(this.length * this.speed, () => {
                res([flares, bg]);
            });
        }).then(([flares,bg]) => {
            SymbolAnim.removeTween(flares);
            SymbolAnim.removeSprite(flares, this.layer);
            SymbolAnim.removeTween(bg);
            SymbolAnim.removeSprite(bg, this.layer);
        });
    }

    displayWild(symbol) {
        let wild_container = new PIXI.Container();
        let diamonds = SymbolAnim.createSprite(symbol.x, symbol.y, "diamonds.png");
        wild_container.addChild(diamonds);
        let text = SymbolAnim.createSprite(symbol.x, symbol.y, "symbol_Wild_text.png");
        wild_container.addChild(text);
        this.layer.addChild(wild_container);
        return wild_container;
    }

    displayShine(symbol) {
        let shine_container = new PIXI.Container();
        let shine = SymbolAnim.createSprite(symbol.x, symbol.y, "symbol_Wild_shine.png");
        let diamonds = SymbolAnim.createSprite(symbol.x, symbol.y, "diamonds_shine.png");
        diamonds.mask = SymbolAnim.createSprite(symbol.x, symbol.y, "diamonds_alpha.png");
        shine_container.addChild(diamonds);
        shine_container.addChild(shine);
        this.layer.addChild(shine_container);
        shine_container.alpha = 0;
        return shine_container;
    }

    shine(symbol, wild_container, shine_container) {
        return new Promise(res => {
            let obj = {x: 1, y: 1};
            createjs.Tween.get(obj)
                .to({x: 0.95, y: 0.95}, 200 * this.speed, createjs.Ease.linear)
                .to({x: 1.05, y: 1.05}, 260 * this.speed, createjs.Ease.linear)
                .to({x: 1.025, y: 1.025}, 620 * this.speed, createjs.Ease.linear)
                .wait(800*this.speed)
                .call(() => {
                    SymbolAnim.removeTween(obj);
                    res([shine_container, wild_container]);
                })
                .addEventListener("change", () => {
                    wild_container.children[0].scale.set(obj.x, obj.y);
                    wild_container.children[1].scale.set(obj.x, obj.y);
                    shine_container.children[0].scale.set(obj.x, obj.y);
                    shine_container.children[1].scale.set(obj.x, obj.y);
                });

            createjs.Tween.get(shine_container)
                .to({alpha: 1}, 460*this.speed, createjs.Ease.circIn)
                .to({alpha: 0.3}, 400*this.speed, createjs.Ease.circIn)
                .call(() => {
                    SymbolAnim.removeTween(shine_container);
                });
        });
    }

    shineLong(symbol, wild_container, shine_container) {
        return new Promise(res => {
            let obj = {x: 1, y: 1};
            createjs.Tween.get(obj)
                .to({x: 0.95, y: 0.95}, 200 * this.speed, createjs.Ease.linear)
                .to({x: 1.05, y: 1.05}, 260 * this.speed, createjs.Ease.linear)
                .to({x: 0.95, y: 0.95}, 400 * this.speed, createjs.Ease.linear)
                .to({x: 1.05, y: 1.05}, 460 * this.speed, createjs.Ease.linear)
                .to({x: 1.025, y: 1.025}, 680 * this.speed, createjs.Ease.linear)
                .wait(300)
                .call(() => {
                    SymbolAnim.removeTween(obj);
                    res([shine_container, wild_container]);
                })
                .addEventListener("change", () => {
                    wild_container.children[0].scale.set(obj.x, obj.y);
                    wild_container.children[1].scale.set(obj.x, obj.y);
                    shine_container.children[0].scale.set(obj.x, obj.y);
                    shine_container.children[1].scale.set(obj.x, obj.y);
                });

            createjs.Tween.get(shine_container)
                .to({alpha: 1}, 460*this.speed, createjs.Ease.circIn)
                .to({alpha: 0.3}, 400*this.speed, createjs.Ease.circIn)
                .call(() => {
                    SymbolAnim.removeTween(shine_container);
                });
        });
    }

    yellowStar(symbol) {
        let x = symbol.x;
        let y = symbol.y;
        let star = SymbolAnim.createSprite(x-80 , y-40, "yellow_star.png");
        star.alpha = 0;
        this.layer.addChild(star);

        this.yellowStars.push(star);

        let path = [
            [
                x-80 , y-40,
                x-45 , y-55,
                x+5  , y-60
            ],
            [
                x+5  , y-60,
                x+45 , y-55,
                x+80 , y-45
            ]
        ];

        createjs.Tween.get(star, {loop:true})
            .to({guide:{ path: path[0]}, alpha: 1}, 400*this.speed)
            .to({guide:{ path: path[1]}, alpha: 0}, 400*this.speed)
            .wait(120*this.speed);
    }

    reflection(symbol) {
        let container = new PIXI.Container();
        let mask = SymbolAnim.createSprite(symbol.x, symbol.y, "symbol_Wild_alpha.png");

        let reflection = SymbolAnim.createSprite(symbol.x-125, symbol.y, "overlay.png");
        container.mask = mask;
        container.addChild(mask);
        container.addChild(reflection);
        this.layer.addChild(container);

        createjs.Tween.get(reflection)
            .wait(300)
            .to({x: symbol.x+150}, 500*this.speed, createjs.Ease.linear)
            .call(() => {
                SymbolAnim.removeTween(reflection);
                SymbolAnim.removeSprite(reflection, container);
            })
    }

    hideDiamonds(shine_container, wild_container) {
        return new Promise(res => {
            let point = {y: shine_container.children[0].y};
            createjs.Tween.get(point)
                .to({y: point.y+75}, 500*this.speed, createjs.Ease.linear)
                .call(() => {
                    SymbolAnim.removeTween(point);
                    res([shine_container, wild_container]);
                })
                .addEventListener("change", () => {
                    //shine_container.children[0].y = point.y;
                    wild_container.children[0].y = point.y;
                });
        });
    }

    showDiamonds(shine_container, wild_container) {
        return new Promise( res => {
            let point = {y: wild_container.children[0].y};
            createjs.Tween.get(point)
                .to({y: point.y-75}, 300*this.speed, createjs.Ease.linear)
                .call(() => {
                    SymbolAnim.removeTween(point);
                    res([shine_container, wild_container]);
                })
                .addEventListener("change", () => {
                    //shine_container.children[0].y = point.y;
                    wild_container.children[0].y = point.y;
                });
        });
    }

    endWildShine (shine_container, wild_container) {
        return new Promise(res => {
            createjs.Tween.get(shine_container)
                .wait(350*this.speed)
                .to({alpha: 0}, 100 * this.speed, createjs.Ease.quadOut)
                .call(() => {
                    SymbolAnim.removeTween(shine_container);
                });
            let obj = {x: 1, y: 1};
            createjs.Tween.get(obj)
                .to({x: 1.025, y: 1.025}, 350 * this.speed, createjs.Ease.quadOut)
                .to({x: 0.95, y: 0.95}, 200 * this.speed, createjs.Ease.quadOut)
                .to({x: 1, y: 1}, 350 * this.speed, createjs.Ease.quadOut)
                .call(() => {
                    SymbolAnim.removeTween(obj);
                    res();
                })
                .addEventListener("change", () => {
                    wild_container.children[0].scale.set(obj.x, obj.y);
                    wild_container.children[1].scale.set(obj.x, obj.y);
                    shine_container.children[0].scale.set(obj.x, obj.y);
                    shine_container.children[1].scale.set(obj.x, obj.y);
                });
        });
    }

    clearStars(callback) {
        for(let star of this.yellowStars)
            SymbolAnim.removeTween(star);
        let val = {alpha: this.yellowStars[0].alpha};
        createjs.Tween.get(val)
            .to({alpha: 0}, 100*this.speed, createjs.Ease.linear)
            .call(() => {
                for(let star of this.yellowStars)
                    SymbolAnim.removeTween(star);
                callback();
            })
            .addEventListener("change", () => {
                for(let star of this.yellowStars)
                    star.alpha = val.alpha;
            })
    }
}